import axios from "axios";
import qs from "qs";
import store from "@/store/index.js";
import route from "@/router/index";
import { Message, Loading } from "element-ui";

const service = axios.create({
  baseURL: process.env.JUMP_LINK,
  timeout: 10000 // 请求超时时间
});

// 请求拦截器 interceptors
service.interceptors.request.use(
  config => {
    // 在此处对 config 进行处理，即发送请求前的操作
    // config.headers['Authorization'] = `Bearer ${store.state.token}`; // 在请求头中添加 authKey 属性并赋值
    return config;
  },
  error => {
    // 请求失败时的处理
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// 响应拦截器 interceptor-----对axios封装响应的数据做拦截
// service.interceptors.response.use(
//   response => {
//     const res = response.data;
//     if (res.code !== 200) {
//       // 成功的 code 码一般是 200，当然 code 字段不一定存在，这里处理请求失败的操作
//       // 可以使用提示框进行消息提示
//       // 在这里还可以进行登录权限的校验
//       if (res.code === 400) {
//         Message.error(res.msg);
//         // 用户无权限可以进行进一步操作，比如超时退出等等
//       }
//       return Promise.reject(new Error(res.msg || "Error"));
//     } else {
//       // 返回正常的请求数据
//       return res;
//     }
//   },
//   error => {
//     // 错误处理函数
//     console.log("err" + error); // for debug
//     return Promise.reject(error);
//   }
// );

// 封装get方法
const get = (url, params) => {
  return service
    .get(url, {
      params
    })
    .then(res => res.data);
};

// 封装postJSON方法。  json格式的数据，一般用于登录接口
const postJSON = (url, data) => {
  return service.post(url, data).then(res => res.data);
};

// 封装post方法   表单格式的数据
const post = (url, data) => {
  return service.post(url, qs.stringify(data)).then(res => res.data);
};

// 最后将 service 进行导出
export { get, postJSON, post };



// WEBPACK FOOTER //
// ./src/assets/api/request.js